/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author        Afternet <info@afternet.gr>
 * @copyright   Afternet
 * @license        http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

export function categoryDropDown(){
    if($('.js-categoryBox-btn').length ){
        $(document).on('click', '.js-categoryBox-btn', function (e){
            console.log('js-categoryBox-btn');
            e.preventDefault();
            $(this).siblings('.js-categoryBox-expand').slideToggle();
        });
    }
}
export function categorySelection(){

    $(document).on('mouseenter', '.js-categorySelection', function (e){
        e.stopPropagation();
        $(this).addClass('opened');
    });
    $(document).on('mouseleave', '.js-categorySelection', function (e){
        e.stopPropagation();
        $(this).removeClass('opened');
    });
    $(document).on('click', '.js-categorySelection', function (e){
        e.preventDefault();
        e.stopPropagation();
        $(this).toggleClass('opened');
    });

    $(document).on('click', '.js-categorySelection-item', function (e){
        e.stopPropagation();
        const _item = $(this).html();
        const _title = $(this).find('.js-categorySelection-item-title').html();

        if( typeof _title != "undefined"){
            $('.js-categorySelection-title').html(_title);
        }
        if( typeof _item != "undefined"){
            $('.js-categorySelection-output').html(_item);
            $('.js-categorySelection-output').find('.col-checkbox').remove();
            $('.js-categorySelection').removeClass('opened');
        }
    });
}

export function productTabs(){

    $(document).on('click', '.js-productTabs-link', function (e){
        e.preventDefault();
        e.stopPropagation();
        $('.js-productTabs-actions-error').hide();
        if( $(this).hasClass('active') ){ return; }

        $(this).siblings('.js-productTabs-link').removeClass('active');
        $(this).addClass('active');
        $(this).parents('.js-productTabs').find('.js-productTabs-tab').removeClass('active');
        $(this).parents('.js-productTabs').find('.js-productTabs-tab').eq($(this).index()).addClass('active');
    });

    $(document).on('click', '.js-productTabs-open', function (e){
        e.preventDefault();
        e.stopPropagation();
        $('.js-productTabs-actions-error').hide();
        $(this).parents('.js-listItem').next('.js-productTabs').first().addClass('opened');
        $('.js-productTabs-overlay').addClass('opened');
    });


}
export function closeTabs(){
    $('.js-productTabs-actions-error').hide();
    $('.js-productTabs').removeClass('opened');
    $('.js-productTabs-overlay').removeClass('opened');
}

export function createTabsListingSpin() {
    if ($('.js-tabListProduct-qnt').length) {
        const spinnerSelector = '.js-tabListProduct-qnt';
        $.each($(spinnerSelector), (index, spinner) => {
            $(spinner).TouchSpin({
                verticalbuttons: false,
                verticalupclass: 'fa fa-angle-up touchspin-up',
                verticaldownclass: 'fa fa-angle-down touchspin-down',
                buttondown_class: 'btn btn-touchspin js-touchspin',
                buttonup_class: 'btn btn-touchspin js-touchspin',
                min: parseInt($(spinner).attr('min'), 10),
                max: parseInt($(spinner).attr('max'), 10),
            });
        });

        // $('body').on('touchspin.on.startdownspin', '.js-tabListProduct-qnt', handleTouchSpin);
        // $('body').on('touchspin.on.startupspin', '.js-tabListProduct-qnt', handleTouchSpin);
        // $('body').on('focusout keyup', '.js-tabListProduct-qnt', handleTouchSpin);
        //
        // function handleTouchSpin(event){
        //     console.log(event);
        //     console.log(event.type);
        //     const _el = $(this).parents('.js-tabListProduct');
        //     const _slot = $(this).parents('.js-productTabs').attr('data-slot');
        //     const _qty = _el.find('.js-tabListProduct-qnt').val();
        //
        //     if (event.type === 'keyup') {
        //         if (event.keyCode === 13) {
        //             $('.js-listItem[data-slot="'+ _slot +'"]').attr('data-productqty', _qty);
        //         }
        //         return false;
        //     }
        //     $('.js-listItem[data-slot="'+ _slot +'"]').attr('data-productqty', _qty);
        //     return false;
        // }
    }
}

export function clearTabErrors(el){
    if(el.find('.js-productTabs-actions-tabs-error').find('.alert').length){
        el.find('.js-productTabs-actions-tabs-error').find('.alert').remove();
    }
}
export function placeTabErrors(el, error){
    if(typeof el != 'undefined'){
        el.find('.js-productTabs-actions-tabs-error').append('<div class="alert alert-danger" role="alert">'+ error +'</div>');
    }
}
export function placeListErrors(value){
    $('.js-kx-flow').append('<div class="alert alert-danger" role="alert">'+ value +'</div>');
}
export function tab_button_animation(){
    $('.js-productList-update').addClass('effect');
    setTimeout(function() {
        $('.js-productList-update').removeClass('effect');
    }, 2000);
}



